module.exports = __webpack_public_path__ + "static/media/hills.876ab4b3.jpg";